import { gql } from "@apollo/client";

export const CREATE_EXTERNAL_BUSINESS_ACCOUNT = gql`
  mutation createExternalBusinessAccount(
    $createExternalBusinessAccountInputs: CreateExternalBusinessAccountInputs!
  ) {
    createExternalBusinessAccount(
      createExternalBusinessAccountInputs: $createExternalBusinessAccountInputs
    ) {
      success
      message
      data {
        _id
        businessInfo {
          name
          email
          phone
        }
        location
        authorizedPerson {
          fullName
        }
        status
        createdAt
      }
    }
  }
`;

export const VERIFY_EXTERNAL_BUSINESS_ACCOUNT = gql`
  mutation verifyExternalBusinessAccount(
    $verifyExternalBusinessAccountInputs: VerifyExternalBusinessAccountInputs!
  ) {
    verifyExternalBusinessAccount(
      verifyExternalBusinessAccountInputs: $verifyExternalBusinessAccountInputs
    ) {
      success
      message
    }
  }
`;
